var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"/","aria-title":"John Diva"}},[_c('img',{attrs:{"src":_vm.logoPath,"alt":"john-diva-logo-2x","width":"520","height":"370"}})])}
var staticRenderFns = []

export { render, staticRenderFns }